import type { RelayMessage } from './types';

const CHANNEL_NAME = 'agencyos-chat';

// Typed BroadcastChannel wrapper for the parent tab <-> popped-out window relay.
// Exists mainly so both ends agree on the message shape and so callers always
// get a close function back — an unclosed channel keeps its listener alive after
// the component that made it is gone.
export interface ChatRelay {
  post(message: RelayMessage): void;
  close(): void;
}

export function openChatRelay(onMessage: (message: RelayMessage) => void): ChatRelay {
  // jsdom in older versions, and any non-browser context, may lack the API.
  // Chat still works without the relay; only pop-out does not.
  if (typeof BroadcastChannel === 'undefined') {
    return { post: () => {}, close: () => {} };
  }

  const channel = new BroadcastChannel(CHANNEL_NAME);
  channel.onmessage = (event: MessageEvent<RelayMessage>) => onMessage(event.data);

  return {
    post: (message) => {
      try {
        channel.postMessage(message);
      } catch {
        // Channel already closed (window tearing down); nothing to recover.
      }
    },
    close: () => {
      channel.onmessage = null;
      channel.close();
    },
  };
}
